import {Injectable} from '@angular/core';
import {EnvironnementProvider, EnvironnementNameEnum} from './environnement-provider.service';
import {EnvironnementRequiredService} from './environnement-required.service';
import {ResponseMessageInterface} from '../../shared/models/responseMessage/responseMessage.interface';
import {AppProvider} from './app-provider.service';
import {ToastDirective} from '../../shared/directives/toast/toast';
import {PlatformContextService} from '../../shared/services/context';
import {LoadingService} from '../../shared/services/loading.service';
import * as env from '../../env/current';
import {UpdateAppService} from "../../shared/services/update-app.service";
import {URLSearchParams} from "@angular/http";
import {EnvironnementService} from "../../shared/services/environnement.service";


@Injectable()
export class EnvironnementInitializer {
  private environnementInconnnu = false;
  private environnementNoInternet = false;
  public captcha = false;
  constructor(
    private appProvider: AppProvider,
    private environnementProvider: EnvironnementProvider,
    private environnementRequiredService: EnvironnementRequiredService,
    private toast: ToastDirective,
    private platformContextService: PlatformContextService,
    private loadingService: LoadingService,
    private updateAppService: UpdateAppService,
    private environnementService: EnvironnementService
  ) {
  }

  public init(): Promise<any> {
    const version: string = this.appProvider.version || '';
    const paramVersion = version ? '?version=' + version : '';
    const client = this.platformContextService.isElu() ? 'APPCE' : 'APPSAL';
    const paramClient = client ? '&client=' + client : '';
    const url: string = this.environnementProvider.production.apiUrl + '/api/version/environnement' + paramVersion + paramClient;

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url);

      xhr.addEventListener('readystatechange', () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.responseText) {
            const response = JSON.parse(xhr.responseText);
            const environnement = response.data.environnement;
            if (environnement) {
              if (xhr.status === 200) {
                this.environnementProvider.default = environnement.environnement;
                this.initRouting().then(() => {

                  this.environnementService.getEnvironnement(version, this.platformContextService.isElu() ? 'APPCE' : 'APPSAL').subscribe((res) => {
                    if (res) {
                      this.captcha = res.captcha;
                    }
                    resolve(response);
                  }, error => {
                    resolve(response);
                  });
                });
              } else if (xhr.status === 400) {
                this.checkError(response);
                resolve(response);
              }
            } else {
              this.environnementInconnnu = true;
              this.environnementProvider.default = EnvironnementNameEnum.prod;
              this.initRouting().then(() => resolve(response));
            }
          } else {
            resolve();
            this.environnementNoInternet = true;
          }
        }
      });

      xhr.send(null);
    });
  }

  public isSupported(): Promise<any> {
    const version: string = this.appProvider.version || '';
    const mode: string = this.appProvider.mode || '';
    // Si l'env n'existe pas sur le serveur, on va pas plus loin
    if (this.environnementInconnnu) {
      // this.toast.createAdv({message: 'L\'environnement ' + version + ' est inconnu sur le serveur', type: 'success'});
      this.toast.createAdv({message: 'IMPORTANT : Une nouvelle version de l’application est disponible sur le store.\n' +
        'Votre version actuelle n’est plus compatible et doit absolument être mise à jour avant toute nouvelle utilisation.\n' +
          'Merci de mettre à jour PocKet\'CE.', type: 'success'});
      this.updateAppService.launchStore('v1');
      return;
    }
    if (this.environnementNoInternet) {
      this.toast.createAdv({
        message: 'Vous n\'avez pas accès à internet. Veuillez régler le problème et relancer l\'application.',
        type: 'success'
      });
      return;
    }
    if (env.default.web) {
      return;
    }
    const paramVersion = version ? '?version=' + version : '';
    const paramMode = mode ? '&mode=' + mode : '';
    const client = this.platformContextService.isElu() ? 'APPCE' : 'APPSAL';
    const paramClient = client ? '&client=' + client : '';
    const url: string = this.environnementProvider.default.apiUrl + '/api/version/supported' + paramVersion + paramClient + paramMode;

    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url);

      xhr.addEventListener('readystatechange', () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          const response = JSON.parse(xhr.responseText);

          if (xhr.status === 200 && null !== response.message) {
            this.toast.createAdv({message: response.message, type: 'success'});
          }

          resolve(response);
        }
      });

      xhr.send(null);
    });
  }

  public initRouting(): Promise<any> {
    const environnement = this.environnementProvider.default;
    this.loadingService.start();
    return Promise.all([
      this.loadScriptAsync(environnement.apiUrl + '/bundles/fosjsrouting/js/router.js'),
      this.loadScriptAsync(environnement.apiUrl + '/js/routing?callback=fos.Router.setData')
    ]).then(() => {
      console.log('Routing succefully loaded');
      this.loadingService.end();
    }).catch(() => {
      console.log('An error has occured when loading the Routing');
      this.loadingService.end();
    });
  }

  public loadScriptAsync(url): Promise<any> {
    return new Promise(function (resolve, reject) {
      const element = document.createElement('script');
      const parent = 'body';
      const attr = 'src';

      // Important success and error for the promise
      element.onload = function () {
        resolve(url);
      };
      element.onerror = function () {
        reject(url);
      };

      element.async = true;
      element[attr] = url;
      document[parent].appendChild(element);
    });
  }

  private checkError(response: ResponseMessageInterface) {
    const data: any = response.data;
    this.environnementRequiredService.message = response.message;
    this.environnementRequiredService.forceUpgrade = data.forceUpgrade;
    this.environnementRequiredService.lockApp = data.lockApp;
  }
}



// WEBPACK FOOTER //
// ./src/core/app/environnement-initializer.service.ts